<template>
  <div id="saved-queries">
    <h4>saved queries</h4>
    <div v-for="(sq, i) in saved_queries" :key="i" class="query">
      <span v-for="(q, qi) in sq" :key="qi">
        <span class="op" :style="{ color: q.color }">{{ q.op }}</span
        >{{ q.val }}
      </span>
      <button @click="searchSaved(i)">
        <md-icon style="color: #9f9;">search</md-icon>
      </button>
      <button @click="deleteSaved(i)">
        <md-icon style="color: #f99;">close</md-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      saved_queries: state => state.search.saved_queries,
    }),
  },

  methods: {
    ...mapActions({
      search: 'search/submit',
      del: 'search/del',
    }),

    searchSaved(i) {
      this.$store.commit('search/SET_QUERY_ARR', this.saved_queries[i])
      this.$store.commit(
        'search/SET_QUERY',
        this.saved_queries[i].map(q => q.val).join(' '),
      )
      this.search()
    },

    deleteSaved(i) {
      this.del(i)
    },
  },
}
</script>

<style scoped>
#saved-queries {
  color: #eee;
  background-color: #333;
  flex: auto;
}
.query {
  margin: 2px;
  background-color: #777;
}
.op {
  font-size: 14px;
  font-weight: bold;
}
</style>
